import { registerTrigger, triggerNamedNotify } from '../../@helpers/js/observer.js';
import { CzSidepanel } from '@cz/webcomponents'; 

function SideOverlay(el, { name = 'zijpaneel' }) {
    const _element = el;

    if (!_element || _element.tagName?.toLowerCase() !== 'cz-sidepanel' || !CzSidepanel.finalized) {
        return;
    }
    
    registerTrigger('sideOverlay_overlayClosing');
    registerTrigger('sideOverlay_overlayOpening');

    const config = {
        attributeFilter: ['open'],
    };
      
    const callback = async (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation.type === "attributes" && mutation.attributeName === 'open') {
                if (_element?.hasAttribute('open')) {
                    return triggerNamedNotify('sideOverlay_overlayOpening', { name });
                } else {
                    return triggerNamedNotify('sideOverlay_overlayClosing', { name });
                }
            }
        }
    };
      
    const observer = new MutationObserver(callback);
    observer.observe(_element, config);

    if (_element?.hasAttribute('open')) {
        triggerNamedNotify('sideOverlay_overlayOpening', { name });
    }
}

export default SideOverlay;